'use client'

import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'
import type { AspectRatioSelectorProps } from './types'

export function AspectRatioSelector({ value, onChange, options }: AspectRatioSelectorProps) {
  return (
    <div className='flex flex-col gap-2 w-full border-b border-gray-100 pb-12'>
      <label htmlFor='aspect-ratio' className='text-sm font-medium text-gray-700'>
        Aspect ratio
      </label>
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger className='w-full h-8 text-sm'>
          <SelectValue placeholder='Select ratio' />
        </SelectTrigger>
        <SelectContent>
          {options.map((option) => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  )
}
